// import gsap from 'gsap'
// import {ScrollTrigger} from 'gsap/dist/ScrollTrigger'
// import {useEffect, useMemo, useRef} from 'react'
// import {useRef} from 'react'

import {LogoNavyInverted as Logo} from '@/assets/specify/'
import {componentTypes} from '@/common/enums'
import {TFooterCol, TFooterItem, TFooterList, TFooterV2} from '@/common/types'
// import DynamicComponent from '@/components/DynamicComponent'
import StoryblokImageV2 from '@/components/StoryblokImageV2/StoryblokImageV2'

import LanguageSwitcher from '../LanguageSwitcher'
import Link from '../Link'
import styles from './FooterV2.module.scss'

// gsap.registerPlugin(ScrollTrigger)

const FooterV2 = ({
  logo,
  homeLink,
  items = [],
  footnote = [],
  copyright = '',
  languages,
}: TFooterV2): JSX.Element => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* <div className={styles.addresses}>
          <div className={styles.logo}>
            <Link link={homeLink}>
              {logo && logo.filename !== '' ? (
                <div className={styles.logowrapper}>
                  <StoryblokImageV2
                    filename={logo.filename}
                    alt={logo.alt}
                    sizes={{sm: 180, unit: 'px'}}
                    width='180'
                    fixedWidth={180}
                  />
                </div>
              ) : (
                <Logo title='Home' style={{height: '50px'}} />
              )}
            </Link>
          </div>
          {addresses.map((props) => {
            if (props.component !== componentTypes.FOOTER_ADDRESS) return null
            return (
              <div key={props._uid} className={styles.address}>
                <DynamicComponent {...props} />
              </div>
            )
          })}
        </div> */}

        <div className={styles.logo}>
          <Link link={homeLink}>
            {logo && logo.filename !== '' ? (
              <div className={styles.logowrapper}>
                <StoryblokImageV2
                  filename={logo.filename}
                  alt={logo.alt}
                  sizes={{sm: 180, unit: 'px'}}
                  width='180'
                  fixedWidth={180}
                />
              </div>
            ) : (
              <Logo title='Home' style={{height: '50px'}} />
            )}
          </Link>
        </div>

        {items.length > 0 && (
          <div className={styles.items}>
            {items.map((props) => {
              const {component, list = []} = props as TFooterCol
              if (component !== 'footer-col' || list.length <= 0) return null
              return (
                <div key={props._uid} className={styles.col}>
                  {list.map((props) => {
                    const {component, title = '', items = []} = props as TFooterList
                    if (component !== 'footer-list') return null
                    return (
                      <div key={props._uid} className={styles.list}>
                        {title !== '' && <p className={styles.listTitle}>{title}</p>}
                        {items.length > 0 && (
                          <div key={props._uid} className={styles.listItems}>
                            {items.map((props) => {
                              const {label, link, component} = props as TFooterItem
                              if (component !== componentTypes.FOOTER_ITEM) return null
                              return <Link key={props._uid} label={label} link={link} />
                            })}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )}

        <hr className={styles.divider} />

        <div className={styles.footnote}>
          {footnote.length > 0 &&
            footnote.map((props) => {
              const {label, link, component} = props as TFooterItem
              if (component !== componentTypes.FOOTER_ITEM) return null
              return (
                <div key={props._uid} className={styles.footnoteItem}>
                  <Link label={label} link={link} />
                </div>
              )
            })}
        </div>

        <div className={styles.copyrightContainer}>
          {copyright !== '' && (
            <div className={styles.copyrightItems}>
              <p className={styles.copyright}>{copyright}</p>
            </div>
          )}
          {languages && (
            <div className={styles.languages}>
              <LanguageSwitcher languages={languages} isLight={true} />
            </div>
          )}
        </div>

        {/* 
        {footnote && (
          <div className={styles.footnote}>
            {footnote.map((props) => {
              if (props.component !== componentTypes.FOOTER_ITEM) return null
              return (
                <div key={props._uid} className={styles.footnoteItem}>
                  <DynamicComponent {...props} />
                </div>
              )
            })}
          </div>
        )} */}
      </div>
    </section>
  )
}

export default FooterV2
